import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import navItems from '../data/navbarData';

function Header() {
    const [fixedHeader, setFixedHeader] = useState(false);

    window.addEventListener("scroll", function () {
        if (window.scrollY > 10) {
            setFixedHeader(true);
        } else {
            setFixedHeader(false);
        }
    });

    return (
        <header id="header" className={fixedHeader && 'header-fixed'}>
            <div className="container">
                <div id="logo" className="pull-left">
                    <h1><a href="#hero">NEEQ-FEUP</a></h1>
                </div>
                <nav id="nav-menu-container">
                    <ul className="nav-menu">
                        {navItems.map((item, index) => (
                            <li key={index}>
                                <a href={item.href} download={item.download ? item.text : undefined}>
                                    {item.text}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <MobileNavigation />
            </div>
        </header>
    );
}

function MobileNavigation() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <>
            <div className="default-mobile-menu-toggle" onClick={toggleMobileMenu}>
                <FontAwesomeIcon icon={faBars} />
            </div>
            <div className={`mobile-navigation ${mobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
                <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
                <ul className="mobile-nav-menu">
                    {navItems.map((item, index) => (
                        <li key={index}>
                            <a href={item.href} download={item.download ? item.text : undefined} onClick={item.href.includes("#") ? toggleMobileMenu : null}>
                                {item.text}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </>

    );
}

export default Header;